<template>
    <div class="login">
        <div class="login__wrap">
            <div class="login__box login__box--join">
                <P class="login__title">비밀번호 찾기</P>
                <div class="login__inputs">
                    
                    <!--로그인 인풋-->
                    <div class="input-box__wrap input-box__wrap--double">
                        <div class="input-box">
                            <label>*아이디</label>
                            <input type="text" v-model="state.id" :disabled="userExist">
                        </div>
                        <div class="input-box">
                            <label>*기관가입 코드</label>
                            <input type="text" v-model="state.orgJoinCode" :disabled="userExist">
                        </div>
                        <div class="input-box">
                            <label>*이메일</label>
                            <input type="text" v-model="state.userMail" :disabled="userExist">
                        </div>
                    </div>
                    <button type="button" class="btn btn--primary btn--half" @click="goFindPW" v-if="!userExist">확인하기</button>
                    <!--로그인 옵션-->
                    <!-- <div class="login__option">
                        <a class="login__option--left" @click="goMenu('user')" src="">로그인하기</a>
                    </div> -->
                    <div class="input-box__wrap input-box__wrap--double" v-if="userExist">
                        <div class="input-box">
                            <label>*비밀번호</label>
                            <input type="password" v-model="state.password">
                        </div>
                        <div class="input-box">
                            <label>*비밀번호 확인</label>
                            <input type="password" v-model="state.passwordConfirm">
                        </div>
                    </div>

                    <button type="button" class="btn btn--primary btn--half" @click="goUpdatePW" v-if="userExist">비밀번호 수정</button>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
    <p class="footer__address">
      08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬) 
      <span>대표전화: 070-4489-7241</span>
    </p>
    <span class="footer__copy">Copyright by 2025 아트너컨설팅. All Right Reserved</span>
  </div>
</template>
   
<script setup>
import { ref, computed, onMounted, onUnmounted ,reactive  } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import * as Utils from '@/common/util/util'
import { updateOrgData } from '@/api/org'
import { findPW,findUpdatePW } from '@/api/user'
const store = useStore()
const router = useRouter()
const checkUserId = computed(() => store.state.temp.userInfo )

const userExist = ref(false)

const state = reactive({
    userMail : '',
    id: '',
    orgJoinCode : '',
    password: '',
    passwordConfirm : '',
});


const checkField = () => {

    if (Utils.isEmpty(state.userMail)) {
		alert("이메일을 입력해주세요")
		return false
	}
    if (Utils.isEmpty(state.id)) {
		alert("아이디를 입력해주세요")
		return false
	}
    if (Utils.isEmpty(state.orgJoinCode)) {
		alert("기관가입 코드를 입력해주세요")
		return false
	}
   
	return true
}

const passwordCheckField = () => {

    if (state.password != state.passwordConfirm) {
        alert("비밀번호와 비밀번호 확인 값이 다릅니다.")
        return false
    }

    if (Utils.isEmpty(state.password)) {
        alert("비밀번호를 입력해주세요")
        return false
    }
    if (Utils.isEmpty(state.passwordConfirm)) {
        alert("비밀번호 확인창을 확인해주세요")
        return false
    }
    return true
}


const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

const goFindPW = async () => {
    if (!checkField()) return false;
    try {
        // 사용자 권한이 'user'일 경우
        let param = {
            userMail: state.userMail,
            orgJoinCode: state.orgJoinCode,
            id : state.id
        };
        let rtn = await findPW(param); // 
        
        if (rtn.result === 'ok') {
            userExist.value = true
        } else {
            alert(rtn.resultMsg);
        }

    } catch (error) {
        console.error("수정 중 오류 발생:", error);
        alert("오류가 발생했습니다. 다시 시도해주세요.");
    }
};

const goUpdatePW = async () => {
    if (!passwordCheckField()) return false;
    try {
        // 사용자 권한이 'user'일 경우
        let param = {
            memberPassword: state.password,
            userMail: state.userMail,
            id : state.id
        };
        let rtn = await findUpdatePW(param); // 
        
        if (rtn.result === 'ok') {
            alert(rtn.resultMsg);
            router.push({ name: 'login' })
        } else {
            alert(rtn.resultMsg);
        }

    } catch (error) {
        console.error("수정 중 오류 발생:", error);
        alert("오류가 발생했습니다. 다시 시도해주세요.");
    }
};

onMounted(async () => {

})
</script>

<style scoped >


/* 📝 페이지 레이아웃 */
.login {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 전체 화면 높이를 채움 */
}

.login__wrap {
  flex: 1; /* 남은 공간을 채움 */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.login__box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
  max-width: 600px;
  width: 100%;
  text-align: center;
}

.login__title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.input-box label {
  font-size: 1rem; /* 라벨 폰트 크기 */
  font-weight: 500;
  margin-bottom: 8px;
  text-align: left;
}

.btn {
  display: inline-block;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn--primary {
  background-color: #007bff;
  color: #fff;
  border: none;
  margin-top: 10px;
}

.btn--primary:hover {
  background-color: #0056b3;
}

.btn--half {
  width: 50%;
  margin: 0 auto;
}

/* 📝 푸터 스타일 */
.footer {
    background-color: #f4f4f4; /* 원하는 배경색 */
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    color: #333;
    margin: 0;
    width: 100%; /* 전체 너비 사용 */
    box-sizing: border-box; /* 패딩과 보더 포함 */
}

.footer__address {
    margin-bottom: 8px;
}

.footer__copy {
  background-color: #f4f4f4;
  font-size: 12px;
  color: #666;
}


/* 📝 반응형 디자인 */
@media (max-width: 768px) {
  .input-box__wrap {
    grid-template-columns: 1fr;
  }

  .btn--half {
    width: 100%;
  }

  .login__box {
    padding: 20px;
  }
}


</style>